export default __webpack_public_path__ + "static/media/gloves_of_fiendish_invocation.0d18f0a1.jpg";